export default __webpack_public_path__ + "static/media/dancin.7886cac8.mp3";